import React, { useState } from 'react';
import OrderListTemplate from './components/OrderListTemplate';
import { MergedOrder, OrderTabScene } from '../../types/process/order';
import OrderTriggerActionMap, { OrderTriggerActionProvider, type OrderTriggerTarget } from './components/OrderTriggerActionMap';
import { getOrderAuditDisplayName, useDefaultQueryFields } from './order.effect';
import { Button, Space, Typography } from 'antd';
import { useStaffMap } from '../../services/store/organization.store';
import ProfitEstimationModal from './components/modals/ProfitEstimationModal';
const { Text } = Typography;

type ProfitEstimationTriggerButtonProps = {
  orderNo: string;
  layout?: 'list' | 'table';
};

const ProfitEstimationTriggerButton: React.FC<ProfitEstimationTriggerButtonProps> = ({ orderNo, layout = 'list' }) => {
  const [open, setOpen] = useState(false);
  const isTable = layout === 'table';

  return (
    <>
      <Button
        type={isTable ? 'link' : 'primary'}
        size="small"
        block={!isTable}
        style={isTable ? { padding: 0 } : undefined}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
      >
        收益测算
      </Button>
      <ProfitEstimationModal
        orderNo={orderNo}
        visible={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

const OrderList: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const reloadList = () => setRefreshKey(k => k + 1);
  const tabScene = OrderTabScene.GroupAll;
  const queryFields = useDefaultQueryFields(tabScene);
  const { staffMap } = useStaffMap();

  const targets: OrderTriggerTarget[] = ['syncRrzuStatus', 'reportView', 'cancelRevoke'];

  const renderTableActions = (order: MergedOrder) => (
    <Space size={4}>
      <OrderTriggerActionMap layout="table" targets={targets} order={order} onReload={reloadList} />
      <Button
        type="link"
        size="small"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          window.open(`/order/audit/${order.order.orderNo}`, '_blank');
        }}
      >
        查看审核详情
      </Button>
      <ProfitEstimationTriggerButton orderNo={order.order.orderNo} layout="table" />
    </Space>
  );

  const renderListInfo = (order: MergedOrder) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <Text style={{ color: '#1677ff' }}>运营: {staffMap.get(order.order.preprocessOperatorId || 0)?.name || '-'}</Text>
      <Text style={{ color: '#1677ff' }}>审核: {getOrderAuditDisplayName(order, staffMap)}</Text>
    </div>
  );

  const renderListActions = (order: MergedOrder) => (
    <Space direction="vertical" style={{ width: '100%' }}>
      <OrderTriggerActionMap layout="list" targets={targets} order={order} onReload={reloadList} />
      <Button
        type="default"
        size="small"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          window.open(`/order/audit/${order.order.orderNo}`, '_blank');
        }}
        style={{ width: '100%' }}
      >
        查看审核详情
      </Button>
      <ProfitEstimationTriggerButton orderNo={order.order.orderNo} layout="list" />
    </Space>
  );

  return (
    <OrderTriggerActionProvider onReload={reloadList}>
      <OrderListTemplate
        refreshKey={refreshKey}
        tabScene={OrderTabScene.GroupAll}
        defaultScene='tab_all'
        queryFields={queryFields}
        viewModes={[
          {
            mode: 'table',
            label: '表格页',
            showField: 'auditStep',
            renderActions: renderTableActions,
          },
          { mode: 'list', label: '产品页', renderActions: renderListActions, renderInfo: renderListInfo },
        ]}
      />
    </OrderTriggerActionProvider>
  );
};

export default OrderList;
